import { motion } from 'framer-motion';

import { LightColorEffect } from './LightColorEffect';

const MotionLightColorEffect = motion.create(LightColorEffect);

export { MotionLightColorEffect };
